(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-stk-announcement]').forEach((bar) => {
        if (bar.dataset.ready) return;
        const track = bar.querySelector('[data-stk-announcement-track]');
        const group = bar.querySelector('[data-stk-announcement-group]');
        if (!track || !group) return;
        bar.dataset.ready = 'true';
        const copy = bar.querySelector('[data-stk-announcement-copy]');
        const viewport = bar.querySelector('.stk-announcement__viewport');
        const originals = Array.from(group.children);
        const duplicate = (node) => {
          const clone = node.cloneNode(true);
          clone.dataset.stkAnnouncementClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('*')].forEach((element) => {
            element.removeAttribute('id');
            element.removeAttribute('data-shopify-editor-block');
          });
          clone.querySelectorAll('a').forEach((link) => link.tabIndex = -1);
          return clone;
        };
        const updateSpeed = () => {
          group.querySelectorAll('[data-stk-announcement-clone]').forEach((clone) => clone.remove());
          const sequenceWidth = originals.reduce((width, node) => width + node.getBoundingClientRect().width, 0);
          if (!sequenceWidth) return;
          const repetitions = Math.max(2, Math.ceil(bar.clientWidth / sequenceWidth) + 1);
          for (let index = 1; index < repetitions; index++) originals.forEach((node) => group.append(duplicate(node)));
          copy.replaceChildren(...Array.from(group.children, duplicate));
          const speed = Math.max(20, Number(bar.dataset.speed) || 32);
          track.style.setProperty('--stk-announcement-duration', group.getBoundingClientRect().width / speed + 's');
          bar.classList.add('is-ready');
        };
        new ResizeObserver(updateSpeed).observe(viewport);
        updateSpeed();
        if (document.fonts) document.fonts.ready.then(updateSpeed);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stak-collections"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-stk-collection-pages]').forEach((box) => {
        if (box.dataset.paginationReady) return;
        const track = box.querySelector('[data-stk-track]');
        const nav = box.querySelector('.stk-cols__nav');
        if (!track || !nav) return;
        box.dataset.paginationReady = 'true';
        const tiles = Array.from(track.children);
        const previous = box.querySelector('[data-stk-prev]');
        const next = box.querySelector('[data-stk-next]');
        const count = box.querySelector('[data-stk-count]');
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        const pad = (value) => String(value).padStart(2, '0');
        let starts = [];
        let active = 0;
        let visible = 1;
        let scheduled = false;
        const offset = (index) => Math.abs(tiles[index].offsetLeft - tiles[0].offsetLeft);
        const position = () => Math.abs(track.scrollLeft);
        const update = () => {
          scheduled = false;
          active = starts.reduce((best, start, index) =>
            Math.abs(offset(start) - position()) < Math.abs(offset(starts[best]) - position()) ? index : best, 0);
          previous.disabled = active === 0;
          next.disabled = active === starts.length - 1;
          count.textContent = pad(active + 1) + ' / ' + pad(starts.length);
          const left = track.getBoundingClientRect().left;
          const right = left + track.clientWidth;
          tiles.forEach((tile) => {
            const rect = tile.getBoundingClientRect();
            tile.inert = rect.right <= left + 2 || rect.left >= right - 2;
          });
        };
        const go = (page) => {
          const index = Math.max(0, Math.min(starts.length - 1, page));
          const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
          track.scrollTo({ left: direction * offset(starts[index]), behavior: reduce.matches ? 'instant' : 'smooth' });
        };
        const rebuild = () => {
          visible = Math.min(tiles.length, Number(getComputedStyle(box).getPropertyValue('--stk-cols-visible')) || 1);
          const last = Math.max(0, tiles.length - visible);
          starts = [0];
          for (let index = visible; index < tiles.length; index += visible) {
            const start = Math.min(index, last);
            if (starts[starts.length - 1] !== start) starts.push(start);
          }
          nav.hidden = starts.length < 2;
          update();
        };
        previous.addEventListener('click', () => go(active - 1));
        next.addEventListener('click', () => go(active + 1));
        track.addEventListener('keydown', (event) => {
          const rtl = getComputedStyle(track).direction === 'rtl';
          let target;
          if (event.key === 'ArrowRight') target = active + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') target = active + (rtl ? 1 : -1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = starts.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          track.focus({ preventScroll: true });
          go(target);
        });
        track.addEventListener('scroll', () => {
          if (scheduled) return;
          scheduled = true;
          requestAnimationFrame(update);
        }, { passive: true });
        box.addEventListener('shopify:block:select', (event) => {
          const index = tiles.indexOf(event.target);
          if (index < 0) return;
          const page = starts.findIndex((start) => index >= start && index < start + visible);
          go(Math.max(0, page));
        });
        new ResizeObserver(rebuild).observe(track);
        rebuild();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
